import { render, staticRenderFns } from "./returnList.vue?vue&type=template&id=7687a621&scoped=true&"
import script from "./returnList.vue?vue&type=script&lang=ts&"
export * from "./returnList.vue?vue&type=script&lang=ts&"
import style0 from "./returnList.vue?vue&type=style&index=0&id=7687a621&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7687a621",
  null
  
)

export default component.exports